import React from "react";

const sejal_pathak = () => {
  return (
    <div>
      <h1>Sejal Pathak</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        There was an online aptitude test on 11th August.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        After getting shortlisted there was a 12 hrs hackathon held at the
        Mastercard office on 25th August, no interviews.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude consisted of two coding questions one was medium and other
        was hard, both had equal marks. It was based on trees and graphs.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        12 students were shortlisted after the Aptitude Round.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        So the hackathon was about 10 days after the announcement of the
        shortlisted students. As it was a hackathon I focused on revising MERN,
        and come up with some probable problem statements for the hackathon and
        worked in that direction along with my team.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        Just one 12 hrs hackathon , no interview rounds . The hackathon starts
        at around 8 am and the problem statements are revealed at that time, the
        hackathon ends with presentations and the announcement of winners.
        <br />
        The internship result was mailed after about 10 days. Out of 12 students
        from COEP 8 were offered final internship at Mastercard and later on
        some students got opportunity for the Navi Mumbai office through an
        interview process.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The mentor evaluated each member of the team based on their ideas,
        innovation, communication skills, quality of work and also ability to
        work in a team.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />I used Strivers AtoZ sheet for DSA , LoveBabbar for DBMS and
        Leetcode to practice DSA, SQL, GFG last minute notes for OOPs, DBMS.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Keep practicing DSA daily, try to cover till medium level questions of
        all topics.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        During the initial online meet with the team and the mentor we were
        asked to introduce ourselves so the mentor got an idea about our
        technical skills, extracurricular activities and also our overall
        personality. It was a casual talk so not much was asked but it does
        create an impression so be prepared.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        For Mastercard we are put into a team of 8 people where mostly other 7
        people are going to be from different colleges. So it is important to
        connect with them as soon as possible and discuss how you are going to
        approach the hackathon as a team. Discussing the tech stack and roles
        each one will undertake is crucial as 12 hrs is a really short time. As
        the mentor is the decision maker communicating your work, thoughts to
        him/her is necessary and also being innovative, creative and trying to
        actually propose some solution is the key to get selected. Our team did
        not win the hackathon but 5 people out of 8 got the internship. Also I
        would like to add prepare System Design a bit before the hackathon as it
        would be useful.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Stay calm, positive and read the internship diaries after you get
        shortlisted for a company to get some idea what a the company expects.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 9022958279
        <br />
        <strong>Email :</strong> <a href="mailto:sejalpathak179@gmail.com">sejalpathak179@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong> 
        <a href="https://www.linkedin.com/in/sejal-pathak-76a857318"> Sejal Pathak</a>
      </p>

      <hr />
    </div>
  );
};

export default sejal_pathak;
